'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (theme) {
    var palette = theme.palette;


    var periodTailsAfter = {
        display: 'block',
        content: '""',
        position: 'absolute',
        width: '2px',
        height: (0, _pixelToNumber2.default)(theme.dateLineHeight) + 10 + 'px',
        background: theme.periodBackground,
        left: '-2px'
    };

    var date = {
        color: theme.dateColor,
        fontSize: theme.dateFontSize,
        lineHeight: theme.dateLineHeight,
        textAlign: 'center',
        padding: '5px',
        boxSizing: 'border-box',
        // line height + padding
        width: (0, _pixelToNumber2.default)(theme.dateLineHeight) + 10 + 'px',
        height: (0, _pixelToNumber2.default)(theme.dateLineHeight) + 10 + 'px',
        margin: '0 auto',
        zIndex: 2,
        position: 'relative',
        userSelect: 'none',
        borderRadius: '50%',
        background: theme.dateBackground,
        transitionTimingFunction: palette.transitionFunction,
        transitionDuration: palette.transitionDuration,
        transitionProperty: 'background, color',

        '&:hover': {
            cursor: 'pointer',
            color: theme.dateColorHover,
            background: theme.dateBackgroundHover
        },

        '&:active': {
            color: theme.dateColorActive,
            background: theme.dateBackgroundActive
        }
    };

    var period = {
        background: theme.periodBackground,
        boxSizing: 'border-box',
        width: '100%',
        height: (0, _pixelToNumber2.default)(theme.dateLineHeight) + 10 + 'px',
        position: 'absolute'
    };

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            font: palette.tsSmall + '/' + palette.tlSmall + ' "' + palette.fontFamily + '"',
            background: theme.background,
            border: '1px solid ' + theme.borderColor,
            color: theme.color,
            boxShadow: theme.boxShadow,
            width: '272px',
            boxSizing: 'border-box',
            zIndex: theme.zIndex
        },
        day: {
            border: '0 none',
            padding: '5px 0',
            position: 'relative',
            width: '36px',
            boxSizing: 'border-box'
        },
        calendar: {
            '& table': {
                width: '100%',
                borderCollapse: 'collapse',
                borderSpacing: 0
            }
        },
        calendarHead: {
            borderBottom: '1px solid ' + theme.borderColor,
            padding: '9px 18px'
        },
        calendarBody: {
            padding: '0 9px 18px 9px',
            width: '270px',
            boxSizing: 'border-box'
        },
        calendarFooter: {
            paddingTop: palette.gutter * 3 + 'px',
            'textAlign': 'right'
        },
        calendarBtnCancel: {
            marginRight: palette.gutter + 'px'
        },
        weekDay: {
            border: '0 none',
            position: 'relative',
            width: '36px',
            boxSizing: 'border-box',
            color: theme.weekColor,
            textAlign: 'center',
            padding: '9px 5px'
        },
        control: {
            border: '0 none',
            position: 'relative',
            boxSizing: 'border-box',
            fontSize: theme.headFontSize,
            lineHeight: theme.headLineHeight,
            textAlign: 'center',
            padding: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        controlLeft: {
            float: 'left'
        },
        controlRight: {
            float: 'right'
        },
        controlDate: {
            // equal to arrows
            lineHeight: '24px'
        },
        date: date,
        dateToday: Object.assign({}, date, {
            color: theme.dateTodayColor,
            background: theme.dateTodayBackground
        }),
        dateDisabled: Object.assign({}, date, {
            color: theme.dateDisabledColor,
            background: theme.dateDisabledBackground,
            cursor: 'not-allowed',

            '&:hover': {
                color: theme.dateDisabledColor,
                background: theme.dateDisabledBackground
            },
            '&:active': {
                color: theme.dateDisabledColor,
                background: theme.dateDisabledBackground
            }
        }),
        datePassive: Object.assign({}, date, {
            '&:hover': {
                background: 'transparent'
            }
        }),
        dateSelected: Object.assign({}, date, {
            color: theme.dateSelectedColor,
            background: theme.dateSelectedBackground,

            '&:hover': {
                color: theme.dateSelectedColor,
                background: theme.dateSelectedBackground
            },
            '&:active': {
                color: theme.dateSelectedColor,
                background: theme.dateSelectedBackground
            }
        }),
        period: period,
        periodStart: Object.assign({}, period, {
            borderBottomLeftRadius: '50%',
            borderTopLeftRadius: '50%',
            width: (0, _pixelToNumber2.default)(theme.dateLineHeight) + 10 + 'px',
            left: '2px',

            '&:after': Object.assign({}, periodTailsAfter, {
                right: '-2px',
                left: 'auto'
            })
        }),
        periodEnd: Object.assign({}, period, {
            borderBottomRightRadius: '50%',
            borderTopRightRadius: '50%',
            width: (0, _pixelToNumber2.default)(theme.dateLineHeight) + 10 + 'px',
            right: '2px',

            '&:after': Object.assign({}, periodTailsAfter)
        }),
        periodCircle: Object.assign({}, period, {
            borderBottomLeftRadius: '50%',
            borderTopLeftRadius: '50%',
            borderBottomRightRadius: '50%',
            borderTopRightRadius: '50%',
            width: (0, _pixelToNumber2.default)(theme.dateLineHeight) + 10 + 'px'
        }),
        periodNoFill: Object.assign({}, period, {
            background: 'transparent',

            '&:after': {
                display: 'none'
            }
        })
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        day: (0, _aphroditeJss.css)(styleList.day),
        periodNoFill: (0, _aphroditeJss.css)(styleList.periodNoFill),
        periodEnd: (0, _aphroditeJss.css)(styleList.periodEnd),
        periodStart: (0, _aphroditeJss.css)(styleList.periodStart),
        periodCircle: (0, _aphroditeJss.css)(styleList.periodCircle),
        period: (0, _aphroditeJss.css)(styleList.period),
        dateSelected: (0, _aphroditeJss.css)(styleList.dateSelected),
        datePassive: (0, _aphroditeJss.css)(styleList.datePassive),
        dateDisabled: (0, _aphroditeJss.css)(styleList.dateDisabled),
        dateToday: (0, _aphroditeJss.css)(styleList.dateToday),
        date: (0, _aphroditeJss.css)(styleList.date),
        controlDate: (0, _aphroditeJss.css)(styleList.controlDate),
        controlRight: (0, _aphroditeJss.css)(styleList.controlRight),
        controlLeft: (0, _aphroditeJss.css)(styleList.controlLeft),
        control: (0, _aphroditeJss.css)(styleList.control),
        weekDay: (0, _aphroditeJss.css)(styleList.weekDay),
        calendarBtnCancel: (0, _aphroditeJss.css)(styleList.calendarBtnCancel),
        calendarFooter: (0, _aphroditeJss.css)(styleList.calendarFooter),
        calendarBody: (0, _aphroditeJss.css)(styleList.calendarBody),
        calendarHead: (0, _aphroditeJss.css)(styleList.calendarHead),
        calendar: (0, _aphroditeJss.css)(styleList.calendar)
    };
};

var _pixelToNumber = require('../../style/pixelToNumber');

var _pixelToNumber2 = _interopRequireDefault(_pixelToNumber);

var _aphroditeJss = require('aphrodite-jss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }